import { createSelector } from 'reselect';
import { createFeatureSelector } from 'features/create-feature-selector';
import { WishlistItem } from '../types';

const featureRootSelector = createFeatureSelector('wishlist');

export const getWishlist = createSelector(featureRootSelector, (b) => b ?? []);
export const getWishlistItem = (productId: WishlistItem['code']) =>
  createSelector(getWishlist, (wishlist) => wishlist?.find((item) => item.code === productId) ?? null);
